import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form, message, notification } from 'antd';
import dayjs from 'dayjs';
import Request from 'common/network/Request';
import _ from 'lodash';
import { BsCheckCircleFill } from 'react-icons/bs';
import { getFirstFieldValidateErrorFromResponse } from 'common/utils/network';
import meetingHistoryApis from 'modules/meeting-history/api';
import SelectTime from 'components/form/elements/SelectTime';
import Note from 'components/form/elements/Note';
import UploadImages from 'components/form/elements/UploadImages';

const NewMeetingHistory = ({ item = {}, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const {
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setError,
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      time: dayjs(),
    },
  });
  const data = watch();

  const handleAddMeeting = async (data) => {
    const { images, note, time } = data;
    setLoading(true);
    try {
      const response = await Request.post(meetingHistoryApis.new_meeting, {
        id: item.id,
        note,
        time: time.unix(),
        images: _.map(images, (image) => ({
          id: image.id,
          path: image.url,
        })),
      });

      if (response && response?.success) {
        message.success('Thêm mới thành công.');
        reset();
        setValue('time', dayjs());
        setErrorMessage(null);
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      } else {
        let mess;
        if (_.isObject(response?.message)) {
          const { message, firstField } =
            getFirstFieldValidateErrorFromResponse(response);

          if (firstField) {
            mess = message;
            setError(firstField, { message });
          }
        } else {
          mess = response?.message || 'Không thể thêm mới. Vui lòng thử lại.';
        }

        notification.error({
          message: 'Lỗi',
          description: mess,
        });
        setErrorMessage(mess);
      }
    } catch (error) {
      const errorMessage =
        error.response?.message || 'Không thể thêm mới. Vui lòng thử lại.';
      notification.error({
        message: 'Lỗi',
        description: errorMessage,
      });
      setErrorMessage(errorMessage);
    }
    setLoading(false);
  };

  return (
    <div>
      <div>
        <h3 className="text-lg font-semibold">Nội dung gặp gỡ</h3>
      </div>
      <Form onFinish={handleSubmit(handleAddMeeting)} layout="vertical">
        <div className="grid grid-cols-12 gap-4 mt-2">
          <div className="md:col-span-6 col-span-12">
            <SelectTime
              control={control}
              errors={errors}
              required
              defaultValue={dayjs()}
            />
            <Note
              label="Nội dung"
              name="note"
              control={control}
              rules={{
                required: 'Hãy nhập nội dung!',
                maxLength: {
                  value: 500,
                  message: 'Nội dung không được vượt quá 500 ký tự!',
                },
              }}
              errors={errors}
              required
            />
          </div>
          <div className="md:col-span-6 col-span-12">
            <UploadImages
              control={control}
              setError={setError}
              errors={errors}
              data={data}
              onUploading={setUploading}
            />
          </div>
        </div>
        {errorMessage && (
          <div
            className="py-2 px-4 mb-2 text-sm text-red-800 rounded-lg bg-red-50 text-center"
            role="alert"
          >
            <span className="">{errorMessage}</span>
          </div>
        )}
        <div className="text-center my-2">
          <Button
            type="primary"
            htmlType="submit"
            icon={<BsCheckCircleFill />}
            loading={loading}
            disabled={uploading}
          >
            Thêm
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default NewMeetingHistory;
